import $ from 'jquery'

$(document).on('click', '.feed-faq__title', function () {
    const bigWrapper = $(this).closest('.container')
    const wrapper = $(this).closest('.feed-faq')
    const content = wrapper.find('.feed-faq__contents')

    const otherWrappers = bigWrapper.find('.feed-faq').not(wrapper)
    otherWrappers.removeClass('feed-faq__active')
    otherWrappers.find('.feed-faq__contents').slideUp(250)

    wrapper.toggleClass('feed-faq__active')
    content.slideToggle(250)
})
